/* src/components/pdf-page-quickscan-result/pdf-page-quickscan-result.component.scss */
/*# sourceMappingURL=pdf-page-quickscan-result.component-CJEQCUWJ.css.map */
